import { convertISOToPhDate } from '~shared/lib/convert-date';

import { documentResourceToFormValues } from './document-resource-to-form-values';

import type { BusinessDetailsFormValues } from '../../model/schemas';
import type { BusinessInfoResponse } from '../../model/types';

export function recoverBusinessInfo(
  businessInfo: BusinessInfoResponse | undefined
): BusinessDetailsFormValues | undefined {
  if (!businessInfo) return undefined;

  return {
    registeredBusinessName: businessInfo.registeredBusinessName,
    registrationDate: convertISOToPhDate(businessInfo.registrationDate),
    tinCode: businessInfo.tinCode,
    brandName: businessInfo.brandName,
    otherFinancingPartners: businessInfo.otherFinancingPartners,
    companyCategories:
      businessInfo.companyCategories?.map((company) => company.id) ?? [],
    companyCategoryOther: businessInfo.companyCategoryOther ?? '',
    ...(businessInfo.brandIcon && {
      brandIcon: documentResourceToFormValues(businessInfo.brandIcon),
    }),
  };
}
